import type { GlossaryData } from '@tyro/i18n';
import { useMemo } from 'react';
import { usePersonalSettings } from '../hooks/use-personal-settings';
import { parseGlossary } from '../utils/parse-glossary';

export function useGlossary(): GlossaryData {
  const { language_translation_glossary } = usePersonalSettings();
  return useMemo(
    () => parseGlossary(language_translation_glossary) as GlossaryData,
    [language_translation_glossary],
  );
}
